<script setup lang="ts">
// Props
interface Props {
  showPreventBenefits: boolean
  pos?: boolean
}
const props = defineProps<Props>()

// Emit
const emit = defineEmits<{
  (e: "closeDialog"): void;
  (e: "goToProfile"): void;
}>();
</script>
<template>
  <VDialog
    :model-value="showPreventBenefits"
    max-width="700"
    max-height="800"
    no-click-animation>
    <VCard>
      <div
        class="d-flex align-center justify-space-between bg-dialogHeaderColor">
        <VCardTitle> All membership benefits are currently on hold </VCardTitle>
        <VBtn
          icon="mdi-close"
          size="large"
          variant="text"
          class="rounded-0"
          color=""
          @click="emit('closeDialog')"
        />
      </div>
      <v-card-text v-if="pos">
        <p>There is an issue with this membership as we have been unable to processes the membership payment.</p>
        <v-alert color="error">Membership Discounts are removed until the Membership balance is current.</v-alert>
      </v-card-text>
      <v-card-text v-else>
        <p>There is an issue with your membership and we have been unable to processes your membership payment.</p>
        <v-alert color="error">Please pay the outstanding amount, and confirm your payment methods in your profile for future payments.</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="!pos" color="primary" variant="flat" @click.prevent="emit('goToProfile')">Add Credit to Profile</v-btn>
        <v-btn color="error" variant="flat" @click.prevent="emit('closeDialog')">Close</v-btn>
      </v-card-actions>
    </VCard>
  </VDialog>
</template>
